import React from "react";
import { RouteObject } from "../../interfaces/navigation";

const BrandPage = React.lazy(() => import("../../containers/BrandPage/EntrypointContainer"));

export const brandPageRoutes: RouteObject[] = [
    {
        path: "/:brandName/autos-0km",
        component: <BrandPage />,
        title: "Concesionarios"
    },
];
